import { useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useRealtimeUpdates = (stockId: string, onUpdate: (data: any[]) => void) => {
  useEffect(() => {
    console.log("Setting up real-time subscription for stock items");
    
    const channel = supabase
      .channel('stock-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'stock_items'
        },
        async () => {
          const { data: updatedProducts, error: fetchError } = await supabase
            .from('stock_items')
            .select('*')
            .eq('stock_id', stockId);

          if (fetchError) {
            console.error("Erreur lors de la récupération des produits:", fetchError);
            return;
          }

          onUpdate(updatedProducts || []);
        }
      )
      .subscribe((status) => {
        console.log("Realtime subscription status:", status);
      });

    return () => {
      console.log("Cleaning up real-time subscription");
      supabase.removeChannel(channel);
    };
  }, [stockId, onUpdate]);
};